import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  companyName: "",
  companyEmail: "",
  businessAddress: "",
  companyLogo: "",
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setCompanyInfo: (
      state,
      action: PayloadAction<{
        companyName: string;
        companyEmail?: string;
        businessAddress: string;
        companyLogo: string;
      }>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateCompanyName: (state, action: PayloadAction<string>) => {
      state.companyName = action.payload;
    },
    updateBusinessAddress: (state, action: PayloadAction<string>) => {
      state.businessAddress = action.payload;
    },
    updateCompanyLogo: (state, action: PayloadAction<string>) => {
      state.companyLogo = action.payload;
    },
  },
});

export const {
  setCompanyInfo,
  updateCompanyName,
  updateBusinessAddress,
  updateCompanyLogo,
} = settingsSlice.actions;

export default settingsSlice.reducer;
